import { API_CONFIG, buildApiUrl } from "../config/api";
import { ApiResponse } from "../types";
import {
  Org,
  CreateOrgDto,
  UpdateOrgDto,
  OrgQueryParams,
  OrgListResponse,
} from "../types/org";
import { http, buildUrl } from "./base";

/**
 * 组织管理相关 API 服务
 */
export class OrgService {
  /**
   * 创建组织（仅管理员）
   * @param data 组织数据
   */
  static async createOrg(data: CreateOrgDto): Promise<ApiResponse<Org>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.ORG.CREATE);
    return http.post(url, data);
  }

  /**
   * 查询组织列表（仅管理员）
   * @param params 查询参数
   */
  static async getOrgList(
    params?: OrgQueryParams
  ): Promise<ApiResponse<OrgListResponse>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ORG.LIST);
    // 只发送有值的参数
    const queryParams: any = {};
    if (params?.name) queryParams.name = params.name;
    if (params?.identifier) queryParams.identifier = params.identifier;
    if (params?.status) queryParams.status = params.status;
    if (params?.page) queryParams.page = params.page;
    if (params?.limit) queryParams.limit = params.limit;
    return http.get(url, queryParams);
  }

  /**
   * 查询组织详情（仅管理员）
   * @param id 组织ID
   */
  static async getOrgDetail(id: number): Promise<ApiResponse<Org>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ORG.DETAIL, {
      id: id.toString(),
    });
    return http.get(url);
  }

  /**
   * 更新组织（仅管理员）
   * @param id 组织ID
   * @param data 更新数据
   */
  static async updateOrg(
    id: number,
    data: UpdateOrgDto
  ): Promise<ApiResponse<Org>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ORG.UPDATE, {
      id: id.toString(),
    });
    return http.patch(url, data);
  }

  /**
   * 删除组织（仅管理员）
   * @param id 组织ID
   */
  static async deleteOrg(id: number): Promise<ApiResponse<void>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ORG.DELETE, {
      id: id.toString(),
    });
    return http.delete(url);
  }

  /**
   * 恢复已删除的组织（仅管理员）
   * @param id 组织ID
   */
  static async restoreOrg(id: number): Promise<ApiResponse<Org>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ORG.RESTORE, {
      id: id.toString(),
    });
    return http.post(url);
  }
}

export default OrgService;

